import React from 'react';
import { Box, CssBaseline, Link, ThemeProvider, Typography } from '@mui/material';
import GetTheApp from './GetTheApp';
import { getDeviceStore } from '../config/appLinks';
import theme from '../theme';

// Page d'installation, rendue hors de l'app (index.js) : elle porte donc son
// propre theme. Deux entrees, une seule page :
//
//  - gated : un telephone a ouvert l'app dans son navigateur, y compris apres
//    avoir scanne le QR affiche sur desktop. Le navigateur mobile n'est pas
//    servi (isBrowserGated), on explique pourquoi et on l'envoie la ou l'app se
//    joue vraiment. C'est le chemin principal.
//  - /get : la meme page a une adresse explicite, pour un lien qu'on ecrit
//    a la main. Attention : l'app est deployee en statique sans reecriture
//    d'URL, donc cette route ne repond qu'une fois une regle serveur en place.
//    Rien de critique n'en depend, le QR vise la racine.
//
// Pas de liste d'attente ici, contrairement a la feuille dans l'app : cette page
// tourne sans compte ni base locale, et une promesse qu'on ne peut pas tenir ne
// vaut pas mieux qu'un "Coming soon" honnete.

const GetAppPage = ({ gated = false }) => {
  const deviceStore = getDeviceStore();
  const appUrl = `${(process.env.PUBLIC_URL || '').replace(/\/+$/, '')}/`;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: '#000',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 3,
          py: 6,
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 380 }}>
          <Box sx={{ textAlign: 'center', mb: 3.5 }}>
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/icons/icon-512.png`}
              alt=""
              sx={{ width: 84, height: 84, borderRadius: '20px', mb: 2.5 }}
            />
            <Typography
              component="h1"
              sx={{ color: 'white', fontSize: '2rem', fontWeight: 600, letterSpacing: '-0.5px' }}
            >
              upScale
            </Typography>
            <Typography
              sx={{
                mt: 1.25,
                color: 'rgba(255,255,255,0.7)',
                fontSize: '1rem',
                lineHeight: 1.5,
              }}
            >
              {gated
                ? 'upScale works on all your devices. Enjoy the full experience everywhere: phone, tablet, or computer at upscale.li/app.'
                : 'Modes, drones and the whole fretboard, guitar in hand. Install it on the device you actually play with.'}
            </Typography>
          </Box>

          <GetTheApp />

          {/* Un desktop qui arrive ici par un lien partage n'a rien a scanner
              s'il veut juste essayer : la version navigateur est complete. */}
          {!gated && !deviceStore && (
            <Typography sx={{ mt: 3.5, textAlign: 'center', fontSize: '0.9rem' }}>
              <Link
                href={appUrl}
                underline="hover"
                sx={{ color: 'rgba(255,255,255,0.6)', '&:hover': { color: 'white' } }}
              >
                Or try it right now in your browser
              </Link>
            </Typography>
          )}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default GetAppPage;
